const tailwind = require('../tailwind')

module.exports = {
  author: 'Bizware',
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "/portfolio"

  siteTitle: 'Bizware-Software developemnt agency', // Navigation and Site Title
  siteTitleAlt: 'ASP.NET.Core | React | Angular | API | PostgreSql', // Alternative Site title for SEO
  siteTitleShort: 'Bizware', // short_name for manifest
  siteHeadline: 'Custom tailored next gen software solutions', // Headline for schema.org JSONLD
  siteUrl: 'https://www.bizware.io', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logo.png', // Used for SEO and manifest
  siteDescription: 'Bizware.io landing page',

  // siteFBAppID: '', // Facebook App ID - Optional
  userTwitter: '@Bizware_io', // Twitter Username
  ogSiteName: '', // Facebook Site Name
  ogLanguage: 'en_US', // Facebook Language
  googleAnalyticsID: '',

  // Manifest and Progress color
  themeColor: tailwind.colors.orange,
  backgroundColor: tailwind.colors.blue,
}
